export default "__VITE_ASSET__D6hV02Fz__"